import PropTypes from "prop-types";

const propTypes = {
  children: PropTypes.node,
  node: PropTypes.object,
};

const ProseMirrorItalicMark = ({ children, node }) => (
  <i data-identifier={node?.identifier}>{children}</i>
);

ProseMirrorItalicMark.propTypes = propTypes;

export default ProseMirrorItalicMark;
